<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { Button } from '~ds/components/ui/button'
import { Icon } from '~ds/components/ui/icon'
import { ICONS } from '~ds/lib/icons'
import { cn } from '~ds/lib/utils'

import { useSidebar } from './utils'

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>()

const { toggleSidebar } = useSidebar()
</script>

<template>
  <Button
    data-sidebar="trigger"
    data-slot="sidebar-trigger"
    variant="ghost"
    size="icon"
    :class="cn('h-7 w-7', props.class)"
    @click="toggleSidebar"
  >
    <Icon :name="ICONS.layoutLeft" size="sm" />
    <span class="sr-only">Toggle Sidebar</span>
  </Button>
</template>
